<template lang="html">
  <div class="input" @click="focusInput">
    <div class="wrapper" :class="{ focussed, error: error, dark: darkmode}">
      <!-- Wenn es ein Icon Input ist dann setze das Icon Attribut auf das Icon -->
      <AveIcon v-if="icon" :icon="icon" :iconType="status" :class="{dark: darkmode}"/>
      <input
        @blur="handleBlur"
        :class="{error: error, dark: darkmode}"
        @focus = "focussed = true"
        @input="handleInput"
        :placeholder="placeholder"
        ref="inputElement"
        type="text"
        :value="value"
      >
      <!-- Zeige eine Fehlermeldung immer dann, wenn es einen fehler gibt -->
    </div>
    <div class="errorMessage">
    <span v-show="error">{{error}}</span>
  </div>
  </div>
</template>

<script>
import AveIcon from '@/components/AveIcon.vue';

export default {
  components: {
    AveIcon,
  },
  props: {
    placeholder: {
      type: String,
      default: 'Project Name, Topic,...',
    },
    darkmode: Boolean,
    error: String,
    value: String,
    icon: String,
    iconType: String,
  },
  computed: {
    status() {
      if (this.error) {
        return 'negative';
      }
      return 'normal';
    },
  },
  data() {
    return {
      focussed: false,
    };
  },
  methods: {
    handleInput(e) {
      this.$emit('input', e.target.value);
    },
    handleBlur() {
      this.focussed = false;
      this.$emit('blurred');
    },
    focusInput() {
      this.focussed = true;
      this.$refs.inputElement.focus();
      // this.value = '';
      // this.error = '';
      this.$emit('focussed');
    },
  },
};
</script>

<style lang="stylus" scoped>
@require '../assets/styles/colors.styl'
@require '../assets/styles/styles.styl'

.input
  display inline-block
  width $inputWidth
  margin-bottom $marginBottom

  .wrapper
    height $inputHeight
    margin auto
    display flex
    align-items center
    flex-direction row
    border $borderBoxes
    border-color $normal
    border-radius $radiusBoxes
    padding-left $paddingInnerLeft

    &.focussed
      border-color: $gray
      color: $gray

      .icon
        color $gray

    &.dark
      border-color $darkmodeWhite
      color $darkmodeWhite

      .icon
        color $darkmodeWhite

    &.error
      border $borderBoxes
      border-color $negative
      color $negative

      .icon
        color $negative

input
  background-color inherit
  border-width 0
  padding-left $paddingIconRight
  padding-right 10px
  width 100%

  &::placeholder
    color $gray

  &:focus
    outline none
    color $gray
    .icon
      color $gray

  &.error
    color $negative
    // &::placeholder
    // color $negative

.errorMessage
  color $negative
  text-align left
  margin-left 6px
  margin-top 4px
</style>
